import * as actions from "actions/accessLevel";
import * as R from "ramda";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case actions.FETCH_ALL_SUCCESS: {
      const accessLevels = {};
      payload.data.forEach(accessLevel => {
        accessLevels[accessLevel.id] = accessLevel;
      });
      return accessLevels;
    }
    case actions.DELETE_ONE_SUCCESS: {
      return R.dissoc(payload.id, state);
    }
    case actions.UPDATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }
    case actions.CREATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/accessLevel/byId.js